import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './EditorBookPageNumbers.css';
import { getCurrentLayout } from '../../redux/helpers';
import { letterOfInvitation, sticker, letterOfInvitationPortrait } from '../../helpers/weddingHelper';

class EditorBookPageNumbers extends Component {
  constructor(...args) {
    super(...args);
    const { lang } = this.props;
    this.texts = {
      cover: lang.cover_front,
      spine: lang.spine,
      reverse: lang.cover_back,
      page: lang.page_number,
      frontFlyLeaf: lang.frontFlyLeaf,
      backFlyFleaf: lang.backFlyLeaf,
      coverText: lang.cover,
    };
  }


  getOddNumbers = (howLongShouldIGo) => {
    const oddNumbers = [];

    for (let number = 0; number <= howLongShouldIGo; number++) {
      if ((number % 2) === 0) {
        continue;
      }
      oddNumbers.push(number);
    }

    return oddNumbers;
  }

  pages(page, pageNumber, layoutType) {
    return this.pageNumbers(pageNumber, layoutType);
  }

  letterOfInvitationNumbers = (layoutType, number, lang) => {
    let text = '';
    switch (number) {
      case 1:
        text = lang.letterOfInvitationFirstPage;
        break;
      case 2:
        text = lang.letterOfInvitationSecondPage;
        break;
      default:
        text = lang.letterOfInvitationSticker;
    }

    return (
      <div className="pages">
        <p>{text}</p>
      </div>
    );
  }

  pageNumbers(number, layoutType) {
    const { lang } = this.props;
    const { page } = this.texts;
    const layoutStickerOrInv = layoutType && (layoutType.type === letterOfInvitation || layoutType.type === sticker || (layoutType.type === letterOfInvitationPortrait));

    if (layoutStickerOrInv) {
      return this.letterOfInvitationNumbers(layoutType, number, lang);
    }

    return (
      <div className="pages">
        <p>{number}{page}</p>
      </div>
    );
  }

  renderPages(page, pageNumber, style, layoutType) {
    return (
      <div className="page-numbers" style={style}>
        {this.pages(page, pageNumber, layoutType)}
      </div>
    );
  }

  render() {
    const {
      style,
      page,
      pageNumber,
      layouts,
    } = this.props;
    const layoutType = getCurrentLayout(layouts, page.layout);

    return this.renderPages(page, pageNumber, style, layoutType);
  }
}

EditorBookPageNumbers.defaultProps = {
  page: {},
  pageNumber: 0,
  style: {
    width: '1320px',
  },
  layouts: {},
};

EditorBookPageNumbers.propTypes = {
  pageNumber: PropTypes.number,
  style: PropTypes.object,
  page: PropTypes.object,
  layouts: PropTypes.object,
};

export default EditorBookPageNumbers;



// WEBPACK FOOTER //
// ./src/components/editor-book-page-numbers/EditorBookPageNumbers.jsx